import { render, staticRenderFns } from "./ConfirmationTypeInfo.vue?vue&type=template&id=a0b1b698&scoped=true"
import script from "./ConfirmationTypeInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConfirmationTypeInfo.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ConfirmationTypeInfo.vue?vue&type=style&index=0&id=a0b1b698&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b1b698",
  null
  
)

export default component.exports